module.exports = __webpack_public_path__ + "img/BLCA_Mast.7c7708b6.png";